var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecklistIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 28C3.45762 28 2 26.5424 2 24.75C2 22.9576 3.45762 21.5 5.25 21.5C7.04238 21.5 8.5 22.9576 8.5 24.75C8.5 26.5424 7.04238 28 5.25 28Z",
    fill: "#F34E4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 8.5C3.45762 8.5 2 7.04238 2 5.25C2 3.45762 3.45762 2 5.25 2C7.04238 2 8.5 3.45762 8.5 5.25C8.5 7.04238 7.04238 8.5 5.25 8.5Z",
    fill: "#F34E4E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4377 17.4375C4.2297 17.4375 4.0217 17.3578 3.86327 17.1994L2.23827 15.5744C1.92058 15.2567 1.92058 14.7432 2.23827 14.4255C2.55595 14.1078 3.06945 14.1078 3.38714 14.4255L4.4377 15.4761L7.92577 11.988C8.24345 11.6703 8.75695 11.6703 9.07464 11.988C9.39233 12.3057 9.39233 12.8192 9.07464 13.1369L5.01214 17.1994C4.8537 17.3578 4.6457 17.4375 4.4377 17.4375Z",
    fill: "#F34E4E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.375 8.5H12.5625C11.6663 8.5 10.9375 7.77119 10.9375 6.875V3.625C10.9375 2.72881 11.6663 2 12.5625 2H26.375C27.2712 2 28 2.72881 28 3.625V6.875C28 7.77119 27.2712 8.5 26.375 8.5Z",
    fill: "#F34E4E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.375 18.25H12.5625C11.6663 18.25 10.9375 17.5212 10.9375 16.625V13.375C10.9375 12.4788 11.6663 11.75 12.5625 11.75H26.375C27.2712 11.75 28 12.4788 28 13.375V16.625C28 17.5212 27.2712 18.25 26.375 18.25Z",
    fill: "#F34E4E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.375 28H12.5625C11.6663 28 10.9375 27.2712 10.9375 26.375V23.125C10.9375 22.2288 11.6663 21.5 12.5625 21.5H26.375C27.2712 21.5 28 22.2288 28 23.125V26.375C28 27.2712 27.2712 28 26.375 28Z",
    fill: "#F34E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistIcon);
export default __webpack_public_path__ + "static/media/checklistIcon.b07d93fd3d827c7e82b7b1ef59909616.svg";
export { ForwardRef as ReactComponent };